module.exports = __webpack_public_path__ + "static/media/Light.aa578129.png";